module.exports = __webpack_public_path__ + "static/media/sell.fbd828cf.svg";